<template>
  <el-dialog
    :title="ADJUST_TITLE[dialogConfig.type]"
    v-model="visible"
    width="60%"
    :close-on-click-modal="false"
    style="overflow: hidden"
  >
    <el-collapse
      v-model="activeName"
      style="overflow-y: auto; height: 55vh"
      v-loading="loading"
    >
      <el-collapse-item title="调整信息" name="msg">
        <el-descriptions
          border
          :column="3"
          v-if="dialogConfig.type == 'detail'"
        >
          <el-descriptions-item
            v-for="item in descriptionList"
            :key="item.value"
            :label="item.label"
            :span="item.span || 1"
            width="16%"
          >
            <span v-if="item.value == 'status'" class="my_class">
              {{ formData[item.value]?.desc }}</span
            >
            <span v-else class="my_class">{{ formData[item.value] }}</span>
          </el-descriptions-item>
        </el-descriptions>
        <el-form
          :model="formData"
          ref="ruleRef"
          label-width="140px"
          :rules="rules"
          v-else
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="盘点单号： " prop="number">
                <el-input
                  v-model="formData.number"
                  placeholder="系统生成"
                  :maxlength="40"
                  v-no-space
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="盘点人员： " prop="checkUser">
                <el-select
                  v-model="formData.checkUser"
                  placeholder="请选择盘点人"
                  style="width: 100%"
                  :disabled="dialogConfig.type == 'edit'"
                >
                  <el-option
                    v-for="item in userList"
                    :key="item.id"
                    :label="item.nikeName"
                    :value="item.userCode"
                  />
                </el-select>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="盘点仓库：" prop="warehouseId">
                <el-select
                  v-model="formData.warehouseId"
                  placeholder="请选择仓库"
                  style="width: 100%"
                  :disabled="dialogConfig.type == 'edit'"
                >
                  <el-option
                    v-for="item in stashList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
          <!-- <el-row :gutter="10">
            <el-col :span="8"
              ><el-form-item label="计划开始日期： " prop="planStart">
                <el-date-picker
                  v-model="formData.planStart"
                  style="width: 100%"
                  type="datetime"
                  placeholder="计划开始日期"
                  @change="formData.planEnd = null"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  :disabled="dialogConfig.type == 'edit'"
                /> </el-form-item
            ></el-col>
            <el-col :span="8"
              ><el-form-item label="计划结束日期： " prop="planEnd">
                <el-date-picker
                  v-model="formData.planEnd"
                  type="datetime"
                  style="width: 100%"
                  placeholder="计划结束日期"
                  :disabled-date="disabledPlanEndTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  :disabled="dialogConfig.type == 'edit'"
                /> </el-form-item
            ></el-col>
          </el-row> -->
          <el-row :gutter="10">
            <el-col>
              <el-form-item label="备注： " prop="remark">
                <el-input
                  v-model="formData.remark"
                  type="textarea"
                  :rows="3"
                  :maxlength="200"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
      <el-collapse-item title="物料调整明细" name="detail">
        <div class="flex">
          <el-text type="primary">总数量： {{ tableData.length }}</el-text>
          <el-button
            type="primary"
            @click="handleMaterielSelect()"
            v-if="dialogConfig.type == 'add'"
            >选择物料</el-button
          >
        </div>
        <el-table
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          class="mt10"
          :data="tableData"
        >
          <el-table-column label="序号" type="index" width="55" />
          <template v-for="item in columns" :key="item.prop">
            <el-table-column
              :label="item.label"
              :prop="item.prop"
              show-overflow-tooltip
            >
              <template #default="{ row }">
                <el-input-number
                  v-model="row[item.prop]"
                  :controls="false"
                  v-if="item.isInput"
                  :min="-999999"
                  :max="999999"
                  :precision="10"
                  style="width: 100%"
                  @blur="checkCountChange(row)"
                />
              </template>
            </el-table-column>
          </template>
          <el-table-column label="操作" v-if="dialogConfig.type == 'add'">
            <template #default="{ row, $index }">
              <el-button type="primary" link @click="handleRemove(row, $index)"
                >移除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleCancel()">取消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit()"
          :disabled="buttonLoading"
          v-if="dialogConfig.type != 'detail'"
        >
          保存
        </el-button>
      </span>
    </template>

    <!-- 物料选择组件 -->
    <WarehouseManagement
      ref="selectRef"
      type="out"
      :validateZero="false"
      @selectDone="materielSelectDone"
    />
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import WarehouseManagement from "@/components/WarehouseManagement.vue";
import { ADJUST_TITLE } from "@/constants";
import { queryCheckByIdNew, insertCheckNew, updateCheck } from "@/api/check";
import useStashList from "@/views/hooks/useStashList";
import { ElMessageBox, ElMessage, tabsEmits } from "element-plus";
import useUserList from "@/views/hooks/useUserList";
import { throttle } from "lodash";

const { stashList } = useStashList();

const { userList } = useUserList();

const emits = defineEmits(["afterSave"]);

// 弹窗控制器
const visible = ref(false);

// 表单ref
const ruleRef = ref(null);

const subRuleRef = ref(null);

// 物料选择ref
const selectRef = ref(null);

// 当前物料列表中已经存在的id
const alreadyExistIds = ref([]);

// 表单数据
const formData = ref({
  number: null,
  checkUser: null,
  warehouseId: null,
  checkDate: null,
  planStart: null,
  planEnd: null,
  startTime: null,
  finishTime: null,
});

// 描述列表
const descriptionList = ref([
  {
    label: "盘点单号",
    value: "number",
  },
  // {
  //   label: "盘点人员",
  //   value: "checkUserName",
  // },
  // {
  //   label: "仓库",
  //   value: "warehouseName",
  // },
  // {
  //   label: "盘点状态",
  //   value: "status",
  // },
  // {
  //   label: "盘点开始日期",
  //   value: "startTime",
  // },
  // {
  //   label: "盘点结束日期",
  //   value: "finishTime",
  // },
  {
    label: "备注",
    value: "remark",
    span: 3,
  },
]);

// 表单校验规则
const rules = reactive({
  // number: [
  //   { required: true, message: "请输入单号", trigger: "blur" },
  //   {
  //     pattern: /^[a-zA-Z0-9]+$/,
  //     message: "只能输入英文和数字",
  //     trigger: "blur",
  //   },
  // ],
  checkUser: [{ required: true, message: "请选择盘点人", trigger: "blur" }],
  warehouseId: [{ required: true, message: "请选择仓库", trigger: "blur" }],
  checkDate: [{ required: true, message: "请选择盘点日期", trigger: "blur" }],
  planStart: [
    { required: true, message: "请选择计划开始日期", trigger: "blur" },
  ],
  planEnd: [{ required: true, message: "请选择计划结束日期", trigger: "blur" }],
  startTime: [
    { required: true, message: "请选择盘点开始日期", trigger: "blur" },
  ],
  finishTime: [
    { required: true, message: "请选择盘点结束日期", trigger: "blur" },
  ],
});

// collapse组件默认展开节点(全部展开)
const activeName = ref(["msg", "detail"]);

// 表格列配置
const columns = ref([]);

// 弹窗loading
const loading = ref(false);

// 保存按钮loading
const buttonLoading = ref(false);

// 接收参数
const dialogConfig = ref({});

// 物料列表
const tableData = ref([]);

// 新增编辑函数
const fns = reactive({
  add: insertCheckNew, // 新增
  edit: updateCheck, // 编辑
});

// 选择物料
const handleMaterielSelect = () => {
  // if (!formData.value.warehouseId) return ElMessage.warning("请先选择仓库");
  selectRef.value?.handleDialogOpen(
    alreadyExistIds.value,
    formData.value.warehouseId,
    false
  );
};

// 弹窗打开
const handleDialogOpen = (config) => {
  dialogConfig.value = config;
  formData.value = {
    number: null,
    checkUser: null,
    warehouseId: null,
    checkDate: null,
    planStart: null,
    planEnd: null,
    startTime: null,
    finishTime: null,
  };
  tableData.value = [];
  alreadyExistIds.value = [];
  ruleRef.value?.resetFields();
  if (config.type != "add") {
    queryDetail(config.row.id);
  }
  if (config.type == "add") {
    columns.value = [
      {
        label: "物料名称",
        prop: "materialName",
      },
      {
        label: "仓库名称",
        prop: "warehouseNameList",
      },
      {
        label: "物料编号",
        prop: "number",
      },
      {
        label: "规格",
        prop: "model",
      },
      {
        label: "单位",
        prop: "unit",
      },
      {
        label: "数量",
        prop: "totalQuantity",
      },
      {
        label: "库存单价",
        prop: "realTimeUnitPrice",
      },
      {
        label: "单价调整",
        prop: "changePrice",
        isInput: true,
      },
    ];
  } else if (config.type == "detail") {
    columns.value = [
      {
        label: "物料名称",
        prop: "materialDTO.name",
      },
      {
        label: "仓库名称",
        prop: "warehouseNameList",
      },
      {
        label: "物料编号",
        prop: "materialDTO.number",
      },
      {
        label: "规格",
        prop: "materialDTO.model",
      },
      {
        label: "单位",
        prop: "materialDTO.unit",
      },
      {
        label: "数量",
        prop: "quantity",
      },
      {
        label: "库存单价",
        prop: "beforePrice",
      },
      {
        label: "单价调整",
        prop: "changePrice",
        isInput: false,
      },
      {
        label: "调整后单价",
        prop: "afterPrice",
      },
    ];
  }
  visible.value = true;
};

// 物料选择结束
const materielSelectDone = (val) => {
  tableData.value = [...val];
  tableData.value.map((i) => {
    (i.inventoryId = i.id), (i.materialName = i.name);
    i.position = i.warehousePositionName;
  });
  alreadyExistIds.value = [];
  tableData.value.forEach((item) => {
    alreadyExistIds.value.push(item.quantityId);
  });
};

// 表单结束时间必须大于开始时间
const disabledEndTime = (time) => {
  if (!formData.value.startTime) return true;
  return (
    Date.parse(formData.value.startTime.replace(/-/g, "/")) > time.getTime()
  );
};

// 计划结束时间必须小于开始时间
const disabledPlanEndTime = (time) => {
  if (!formData.value.planStart) return true;
  return (
    Date.parse(formData.value.planStart.replace(/-/g, "/")) > time.getTime()
  );
};

// 点击保存
const handleSubmit = () => {
  if (buttonLoading.value) return;
  buttonLoading.value = true;
  ruleRef.value?.validate((valid) => {
    if (valid) {
      ElMessageBox.confirm("请确认盘点结果是否准确，提交后不允许修改", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          // if (dialogConfig.value.type == "edit") {
          //   if (!formData.value.startTime || !formData.value.finishTime) {
          //     buttonLoading.value = false;
          //     return ElMessage.error("请选择盘点开始、结束时间");
          //   }
          // }
          const adReqList = [...tableData.value];
          adReqList.map((i) => {
            i.id = null;
            i.beforePrice = i.realTimeUnitPrice;
            i.quantity = i.totalQuantity;
          });
          let reqBody = {
            ...formData.value,
            adReqList,
          };
          adjustCheck(reqBody);
        })
        .catch(() => {
          ElMessage.info("已取消");
          buttonLoading.value = false;
        });
    } else {
      buttonLoading.value = false;
    }
  });
};

// 点击取消
const handleCancel = () => {
  ruleRef.value?.resetFields();
  visible.value = false;
};

// 新增或编辑
const adjustCheck = (req) => {
  fns[dialogConfig.value.type](req).then((res) => {
    if (res.code == "2000") {
      ElMessage.success("操作成功");
      emits("afterSave");
      visible.value = false;
    }
  });
  setTimeout(() => {
    buttonLoading.value = false;
  }, 1000);
};

// 根据id获取信息
const queryDetail = (id) => {
  loading.value = true;
  queryCheckByIdNew(id)
    .then((res) => {
      Object.assign(formData.value, res.data);
      tableData.value = res.data.detailDTOList;

      alreadyExistIds.value = [];
      tableData.value.forEach((item) => {
        alreadyExistIds.value.push(item.quantityId);
        checkCountChange(item);
      });
    })
    .finally(() => {
      loading.value = false;
    });
};

// 点击表格移除
const handleRemove = (row, index) => {
  tableData.value.splice(index, 1);

  const arr = alreadyExistIds.value.filter((id) => id != row.quantityId);

  alreadyExistIds.value = arr;
};

// 盘点数量变化
const checkCountChange = (row) => {
  // if (row.count == null) return (row.checkResult = "未盘点");
  // if (row.count > row.inventoryNumber) {
  //   row.checkResult = "盘盈";
  // } else if (row.count < row.inventoryNumber) {
  //   row.checkResult = "盘亏";
  // } else if (row.count == row.inventoryNumber) {
  //   row.checkResult = "盘平";
  // }
};

defineExpose({
  handleDialogOpen,
});
</script>

<style scoped>
.flex {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.mt10 {
  margin-top: 10px;
}
.my_class {
  max-width: 100%;
  word-break: break-all;
  word-wrap: break-word;
}
</style>
